import React from "react";

const TestFail = () => {
  return <div>Test Fail</div>;
};

export default TestFail;
